class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* „MEHR ↓" IM MEGA-MENUE (Pruefrunde 1 Phase B, regression #4): scrollt das Panel
   intern (max-height an der Kopfunterkante), traegt es data-mehr, solange darunter
   noch Inhalt kommt — daran haengt der Knopf [data-mega-mehr] (component-mega-
   menu.css). Gemessen wird nur beim Oeffnen und beim Scrollen (Nutzerhandlung). */
function apMegaMehr(inhalt) {
  if (!inhalt || typeof inhalt.querySelector !== 'function') return;
  const knopf = inhalt.querySelector('[data-mega-mehr]');
  if (!knopf) return;
  const setzen = () => {
    const rest = inhalt.scrollHeight - inhalt.scrollTop - inhalt.clientHeight;
    inhalt.toggleAttribute('data-mehr', rest > 8);
  };
  if (!inhalt.apMehrBereit) {
    inhalt.apMehrBereit = true;
    inhalt.addEventListener('scroll', setzen, { passive: true });
    knopf.addEventListener('click', () => {
      const ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      inhalt.scrollBy({ top: Math.round(inhalt.clientHeight * 0.7), behavior: ruhig ? 'auto' : 'smooth' });
    });
  }
  window.requestAnimationFrame(setzen);
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    /* Bei JEDEM Oeffnen neu messen (Audit 24.09., einstieg-megamenue-
       unerreichbar). Dawn setzte den Wert nur beim ERSTEN Oeffnen und liess
       ihn danach stehen. Seit component-mega-menu.css die Panelhoehe auch
       ausserhalb des Klebezustands daraus rechnet, waere ein alter Wert
       falsch: zuerst im Klebezustand geoeffnet (Kopf kurz), dann oben auf der
       Seite (Kopf 251 px hoch) — das Panel ragte wieder unter den Bildrand.
       Beim Schliessen wird nicht gemessen; der Wert gilt nur fuer offene
       Panels. */
    if (!this.mainDetailsToggle.open) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
    apMegaMehr(this.content);
  }
}

customElements.define('header-menu', HeaderMenu);
